import React, { useEffect, useState } from "react";
import "./style.css";
import RatingView from "../../../RatingView";
import AdminSeatBooking from "../../AdminSeatBooking";
import { getBookingFormatedDateMonthTimeValue, getBookingFormatedDateMonthValue, getBookingFormatedValue, isTravelDateGreaterThanPointTime } from "../../../../utils/Functions";
import { useParams } from "react-router-dom";
import { TagColor } from "../../../../utils/common.data";
import { Chip } from "@mui/material";

const AdminCabItem = ({
  busValue,
  id,
  name,
  images,
  departure,
  arrival,
  duration,
  rating,
  price,
  seatsAvailable,
  fetchCategories,
  viewSeatId,
  setViewSeatId,
  handleApiRedirect,
  tripDetail,  
  categoryTags
}) => {
  const params = useParams()
  const [viewSeat, setViewSeat] = useState({
    open: false,
    busId: "",
    busDetail: {},
  });
  const [searchDetail, setSearchDetail] = useState({
    boarding: "",
    dropping: "",
    travel_date: "",
  });

  useEffect(() => {
    const searchData = sessionStorage.getItem("bookingdetails");
    if (searchData) {
      try {
        const searchValue = JSON.parse(searchData);
        setSearchDetail({
          ...searchDetail,
          ...searchValue,
          travel_date: searchValue?.date,
        });
      } catch (error) {
        console.log(`search Data Err`, error);
      }
    }
  }, []);

  const handleSeatView = (id) => {
    if (id === viewSeatId) {
      setViewSeat({ ...viewSeat, open: false, busId: "" });
      setViewSeatId(null)
      return;
    }
    fetchCategories()
    setViewSeat({
      busId: id,
      open: true,
      busDetail: {
        ...busValue,
        id,
        name,
        images,
        rating,
        price,
      },
    });
    setViewSeatId(id)
  };

  const handleBoardingView = (busSelect) => {
    const dataValue = busSelect?.boarding_points?.sort((a, b) => {
      return new Date(a.time) - new Date(b.time);
    })
    const value = dataValue[0];
    return value ? <>
          <div className="depart_time">{getBookingFormatedValue(new Date(busSelect?.departure))}</div>
          <span className="span_descp_desktop">{value?.title}</span>
        </> : <>
          <div className="depart_time">{getBookingFormatedValue(new Date(busSelect?.departure))}</div>
          {/* {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view_card">{getBookingFormatedDateMonthValue(new Date(busSelect?.departure))}</div>} */}
        </>
  };

  const handleDroppingView = (busSelect) => {
    const dataValue = busSelect?.dropping_points?.sort((a, b) => {
      return new Date(b.time) - new Date(a.time);
    })
    const value = dataValue[0];
    return value ? <><div className="arrival_time">{getBookingFormatedValue(new Date(busSelect?.arrival))}</div>
          {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view_card">{getBookingFormatedDateMonthValue(new Date(busSelect?.arrival))}</div>}
          <span className="span_descp_desktop">{value?.title}</span>
        </> : <>
          <div className="arrival_time">{getBookingFormatedValue(new Date(busSelect?.arrival))}</div>
          {/* {isTravelDateGreaterThanPointTime(busSelect?.arrival, busSelect?.departure) && <div className="extra_date_view_card">{getBookingFormatedDateMonthValue(new Date(busSelect.arrival))}</div>} */}
        </>
  };

  return (
    <section
      style={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}
    >
      <div className="admin_bus_item_main booking_bus_item_main st_calender_contant_main_wrapper st_calender_row_cont float_left">
        <div className="booking_bus_item_main_card">
          <div className="w_30 st_calen_asc_heart_cont booking_bus_title">
            <h3 className="booking_bus_title_desktop">{name}</h3>
            <h3 className="booking_bus_title_mobile">{name}</h3>

                        {busValue?.cat_tags?.length > 0 && categoryTags?.length > 0 &&
                    <div className={`booking_bus_item_main_tags`}>
                    <aside className="booking_bus_item_main_tags_left">
                      <div className="booking_bus_item_main_tags_left_value">
                        {categoryTags?.length > 0 && categoryTags.filter((value) => busValue?.cat_tags?.includes(value?.value)).map((item, index) => {
                          return (
                            <Chip
                                                    key={item.value}
                                                    label={item?.title}
                                                    sx={{backgroundColor: TagColor[index]}}
                                                    className="booking_bus_item_main_tags_left_value_chips"
                                                  />
                          );
                        })}
                      </div>
                    </aside>
                  </div>
                  }
            {/* <div className="booking_bus_item_main_card_image">
              <img className="booking_bus_item_main_card_image_tag" src={images} alt={name} />
            </div> */}
          </div>
          <div className="booking_bus_item_main_content">
            <div className="fl pr_10 w_10 booking_bus_item_main_content_depart">
              <span className="span_title_mobile">Departure</span>
              {handleBoardingView(busValue)}
            </div>
            <div className="fl pr_10 w_10 booking_bus_item_main_content_duration">
              <span className="span_title_mobile">Duration</span>
              <div className="duration_time">{duration}</div>
            </div>
            {/* Width Change 10 to 20 Due To Rating And booking_bus_item_main_content justicy center Removed */}
            <div className="fl pr_10 w_20 booking_bus_item_main_content_arrival">
              <span className="span_title_mobile">Arrival</span>
              {handleDroppingView(busValue)}
            </div>
            {/* <div className="fl pr_10 w_10 booking_bus_item_main_content_rate">
              <span className="span_title_mobile">Rating</span>
              <RatingView rating={rating} />
            </div> */}
            <div className="fl pr_10 w_15 booking_bus_item_main_content_fare">
              <span className="span_title_mobile" style={{ fontWeight: 'normal' }}>Fare</span>
              {/* <div className="price_text">Starts from</div> */}
              <span>&#8377; {price}</span>
            </div>
            <div className="fl w_10 booking_bus_item_main_content_seat">
              <span className="span_title_mobile">Seat Available</span>
              <div className="seat_available common_align_center">
                {seatsAvailable == 0 ? "Fully Booked" : seatsAvailable}
              </div>
            </div>
          </div>
        </div>
        {seatsAvailable !== 0 && <div className="booking_bus_item_button_main">
          <button
            type="button"
            className={`booking_bus_item_button ${viewSeatId == id ? "booking_bus_item_button_open" : ""
              }`}
            disabled={params?.id}
            onClick={() => {
              handleSeatView(id);
            }}
          >
            {/* {viewSeatId == id ? "Hide Seats" : "Select Seats"} */}
            Book
          </button>
        </div>}
      </div>
      {id == viewSeatId && <AdminSeatBooking busSelect={{ ...viewSeat.busDetail, ...busValue }} fetchCategories={fetchCategories} handleApiRedirect={handleApiRedirect} tripDetail={tripDetail} />}
    </section>
  );
};

export default AdminCabItem;
